import { useCallback, useRef, useState } from 'react';

export default function useCountdown(time = 5) {
  const intervalRef = useRef<NodeJS.Timeout | number>();
  const [timeLeft, setTimeLeft] = useState(0);

  const clearCountdown = useCallback(() => {
    clearInterval(intervalRef.current as number);
    intervalRef.current = undefined;
    setTimeLeft(0);
  }, []);

  const startCountdown = useCallback(() => {
    clearInterval(intervalRef.current as number);
    setTimeLeft(time);

    intervalRef.current = setInterval(() => {
      setTimeLeft((old) => {
        if (old <= 1) {
          clearInterval(intervalRef.current as number);
          intervalRef.current = undefined;
          return 0;
        }
        return old - 1;
      });
    }, 1000);
  }, [time]);

  return { timeLeft, startCountdown, clearCountdown } as const;
}
